import moment from 'moment';

const FORMATO = 'YYYY-MM-DDTHH:mm:ss';

const empresa = (id, nome, cnpj, municipio, estado, latitude, longitude) => ({
    id,
    emp_nome_fantasia: nome,
    emp_razao_social: `${nome} Ltda`,
    emp_cnpj: cnpj,
    emp_municipio: municipio,
    emp_estado: estado,
    emp_latitude: latitude,
    emp_longitude: longitude,
    emp_logradouro: 'Rodovia BR-163',
    emp_logradouro_numero: 'km 740',
    emp_bairro: 'Distrito Industrial',
});

export const EMBARCADORAS = [
    empresa(9101, 'Agro Norte', '11222333000181', 'Sorriso', 'MT', -12.5425, -55.7211),
    empresa(9102, 'Cooperativa Planalto', '22333444000172', 'Rio Verde', 'GO', -17.7923, -50.9192),
];

export const ARMAZENS = {
    sorriso: empresa(9201, 'Armazém Sorriso', '33444555000163', 'Sorriso', 'MT', -12.5425, -55.7211),
    cuiaba: empresa(9202, 'Armazém Cuiabá', '44555666000154', 'Cuiabá', 'MT', -15.601, -56.0974),
    rioVerde: empresa(9203, 'Armazém Rio Verde', '55666777000145', 'Rio Verde', 'GO', -17.7923, -50.9192),
    santos: empresa(9204, 'Terminal Santos', '66777888000136', 'Santos', 'SP', -23.9608, -46.3336),
    paranagua: empresa(9205, 'Terminal Paranaguá', '77888999000127', 'Paranaguá', 'PR', -25.5205, -48.5095),
};

const PRODUTOS = {
    soja: { id: 9301, nome: 'Sacaria 50 kg', produto_nome: 'Soja' },
    milho: { id: 9302, nome: 'Granel', produto_nome: 'Milho' },
    adubo: { id: 9303, nome: 'Big Bag 1000 kg', produto_nome: 'Adubo NPK' },
};

export const MOTORISTAS = [
    { nome: 'João Pereira', cpf: '12345678901', cnh: '01234567890', celular: '65999990001', email: 'joao@exemplo.com' },
    { nome: 'Carlos Almeida', cpf: '23456789012', cnh: '12345678901', celular: '65999990002', email: 'carlos@exemplo.com' },
    { nome: 'Marcos Silva', cpf: '34567890123', cnh: '23456789012', celular: '65999990003', email: 'marcos@exemplo.com' },
    { nome: 'Rafael Costa', cpf: '45678901234', cnh: '34567890123', celular: '65999990004', email: 'rafael@exemplo.com' },
];

export const TRANSPORTADORAS = [
    { id: 9401, emp_nome_fantasia: 'Translog Sul', emp_cnpj: '88999000000118' },
    { id: 9402, emp_nome_fantasia: 'Rota Forte', emp_cnpj: '99000111000109' },
    { id: 9403, emp_nome_fantasia: 'Carga Brasil', emp_cnpj: '10111222000190' },
];

export const TRANSPORTADORA_DA_SESSAO = TRANSPORTADORAS[0];

export const RASTREAMENTO = { empresa: 'FASTFRETE TECNOLOGIA E LOGÍSTICA S.A.', cnpj: '34424320000190', id_receptor: '1545562555' };

export const HORARIOS_DE_CARREGAMENTO = ['06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '13:00', '14:00', '15:00', '16:00'];

export const PONTOS_DA_ROTA = [
    { latitude: -12.5425, longitude: -55.7211 },
    { latitude: -13.8, longitude: -55.9 },
    { latitude: -15.601, longitude: -56.0974 },
    { latitude: -18.5, longitude: -54.7 },
    { latitude: -20.4, longitude: -51.4 },
    { latitude: -22.2, longitude: -48.8 },
    { latitude: -23.9608, longitude: -46.3336 },
];

const CADENCIA_SEMANAL = { SEG: 300, TER: 300, QUA: 300, QUI: 300, SEX: 300 };
const CADENCIA_COM_SABADO = { SEG: 450, TER: 450, QUA: 450, QUI: 450, SEX: 450, SAB: 150 };

const operacao = (distribuicao) => Object.fromEntries(Object.entries(distribuicao).map(([etapa, [veiculos, volume]]) => [etapa, { veiculos, volume }]));

const oferta = (id, status, deslocamentoInicio, duracaoEmDias, base) => ({
    id,
    numero: String(1000 + id),
    status,
    data_inicio_operacao: moment().startOf('day').add(deslocamentoInicio, 'days').hour(7).format(FORMATO),
    data_fim_operacao: moment().startOf('day').add(deslocamentoInicio + duracaoEmDias, 'days').hour(18).format(FORMATO),
    tipos_caminhao: ['Carreta', 'Bitrem'],
    quantidades_eixos: [5, 6],
    tipos_carroceria: ['Graneleira'],
    movimentacao_liberada: status === 'em_andamento',
    orientacoes_motorista: 'Apresentar documentação na guarita e utilizar a balança antes do carregamento.',
    valores_por_eixo: [
        { quantidade_eixos: 5, valor_por_tonelada: 168.5 },
        { quantidade_eixos: 6, valor_por_tonelada: 181 },
    ],
    valor_medio_com_icms_por_tonelada: 174.75,
    valor_total_estimado: 0,
    divulgacao: { tipo_cerca: 'circular', raio_km: 150, pontos: [] },
    observacao: null,
    numero_di: null,
    nome_navio: null,
    ...base,
});

const comTotalEstimado = (item) => ({ ...item, valor_total_estimado: Math.round(item.volume_total * item.valor_medio_com_icms_por_tonelada) });

export const criarOfertasIniciais = () => [
    oferta(1, 'em_andamento', -6, 24, {
        embarcadora: EMBARCADORAS[0],
        armazem_origem: ARMAZENS.sorriso,
        armazem_destino: ARMAZENS.santos,
        patio_origem: null,
        patio_destino: null,
        remetente: EMBARCADORAS[0],
        destinatario: EMBARCADORAS[1],
        produto_acondicionamento: PRODUTOS.soja,
        tipo_documento: 'OV',
        numero_documento: '4500123',
        numero_pedido: null,
        volume_total: 6000,
        volumes: { agendado: 2400, carregado: 1980, descarregado: 1320, avaria_kg: 640 },
        operacao: operacao({
            agendado: [18, 540], a_caminho_carregamento: [6, 180], aguardando_carregamento: [4, 120], carregado: [9, 270],
            em_transito: [22, 660], a_caminho_descarga: [5, 150], aguardando_descarregamento: [3, 90], descarregado: [44, 1320],
        }),
        cadencia: CADENCIA_COM_SABADO,
    }),
    oferta(2, 'em_andamento', -3, 18, {
        embarcadora: EMBARCADORAS[1],
        armazem_origem: ARMAZENS.rioVerde,
        armazem_destino: ARMAZENS.paranagua,
        patio_origem: null,
        patio_destino: null,
        remetente: EMBARCADORAS[1],
        destinatario: EMBARCADORAS[0],
        produto_acondicionamento: PRODUTOS.milho,
        tipo_documento: null,
        numero_documento: null,
        numero_pedido: 'PED-7788',
        volume_total: 4200,
        volumes: { agendado: 1500, carregado: 900, descarregado: 300, avaria_kg: 0 },
        operacao: operacao({
            agendado: [12, 360], a_caminho_carregamento: [3, 90], aguardando_carregamento: [2, 60], carregado: [5, 150],
            em_transito: [10, 300], a_caminho_descarga: [2, 60], aguardando_descarregamento: [1, 30], descarregado: [10, 300],
        }),
        cadencia: CADENCIA_SEMANAL,
    }),
    oferta(3, 'em_analise', 5, 20, {
        embarcadora: EMBARCADORAS[0],
        armazem_origem: ARMAZENS.sorriso,
        armazem_destino: ARMAZENS.cuiaba,
        patio_origem: null,
        patio_destino: null,
        remetente: EMBARCADORAS[0],
        destinatario: EMBARCADORAS[0],
        produto_acondicionamento: PRODUTOS.adubo,
        tipo_documento: 'Contrato',
        numero_documento: 'CT-2026-88',
        numero_pedido: null,
        volume_total: 2500,
        volumes: { agendado: 0, carregado: 0, descarregado: 0, avaria_kg: 0 },
        operacao: operacao({}),
        cadencia: CADENCIA_SEMANAL,
    }),
    oferta(4, 'finalizado', -40, 30, {
        embarcadora: EMBARCADORAS[1],
        armazem_origem: ARMAZENS.rioVerde,
        armazem_destino: ARMAZENS.santos,
        patio_origem: null,
        patio_destino: null,
        remetente: EMBARCADORAS[1],
        destinatario: EMBARCADORAS[1],
        produto_acondicionamento: PRODUTOS.soja,
        tipo_documento: 'OV',
        numero_documento: '4500077',
        numero_pedido: null,
        volume_total: 3000,
        volumes: { agendado: 3000, carregado: 3000, descarregado: 2985, avaria_kg: 1500 },
        operacao: operacao({ descarregado: [100, 2985] }),
        cadencia: CADENCIA_SEMANAL,
    }),
    oferta(5, 'rascunho', 10, 15, {
        embarcadora: EMBARCADORAS[0],
        armazem_origem: ARMAZENS.sorriso,
        armazem_destino: ARMAZENS.paranagua,
        patio_origem: null,
        patio_destino: null,
        remetente: EMBARCADORAS[0],
        destinatario: EMBARCADORAS[0],
        produto_acondicionamento: PRODUTOS.milho,
        tipo_documento: null,
        numero_documento: null,
        numero_pedido: null,
        volume_total: 1800,
        volumes: { agendado: 0, carregado: 0, descarregado: 0, avaria_kg: 0 },
        operacao: operacao({}),
        cadencia: {},
    }),
    oferta(6, 'suspensa', -10, 25, {
        embarcadora: EMBARCADORAS[1],
        armazem_origem: ARMAZENS.rioVerde,
        armazem_destino: ARMAZENS.cuiaba,
        patio_origem: null,
        patio_destino: null,
        remetente: EMBARCADORAS[1],
        destinatario: EMBARCADORAS[1],
        produto_acondicionamento: PRODUTOS.adubo,
        tipo_documento: null,
        numero_documento: null,
        numero_pedido: 'PED-5521',
        volume_total: 3500,
        volumes: { agendado: 900, carregado: 600, descarregado: 450, avaria_kg: 90 },
        operacao: operacao({ agendado: [8, 240], carregado: [6, 180], descarregado: [15, 450] }),
        cadencia: CADENCIA_SEMANAL,
    }),
].map(comTotalEstimado);

const STATUS_E_ETAPA_DA_VIAGEM = [
    ['agendado', 'agendado'],
    ['a_caminho_carregamento', 'a_caminho_carregamento'],
    ['patio_origem', 'aguardando_carregamento'],
    ['aguardando_carregamento', 'aguardando_carregamento'],
    ['carregado', 'carregado'],
    ['em_transito', 'em_transito'],
    ['em_transito', 'em_transito'],
    ['patio_destino', 'a_caminho_descarga'],
    ['aguardando_descarga', 'aguardando_descarregamento'],
    ['descarregado', 'descarregado'],
    ['finalizado', 'descarregado'],
    ['finalizado', 'descarregado'],
];

const SITUACOES = ['dentro_previsto', 'dentro_previsto', 'atencao', 'atrasado', 'sem_sinal', 'em_local_operacional'];

const PLACAS = ['ABC1D23', 'QWE4R56', 'JKL7M89', 'PLM2N34', 'TRE5S67', 'ZXC8V90'];

const resumoDaOferta = (item) => ({
    id: item.id,
    numero: item.numero,
    tipo_documento: item.tipo_documento,
    numero_documento: item.numero_documento,
    embarcadora: item.embarcadora,
    produto_nome: item.produto_acondicionamento?.produto_nome,
    armazem_origem: item.armazem_origem,
    armazem_destino: item.armazem_destino,
});

export const criarViagens = (ofertas) => ofertas
    .filter((item) => ['em_andamento', 'finalizado', 'suspensa'].includes(item.status))
    .flatMap((item, indiceDaOferta) => STATUS_E_ETAPA_DA_VIAGEM.map(([status], indice) => {
        const sequencia = indiceDaOferta * 20 + indice + 1;
        const motorista = MOTORISTAS[(sequencia) % MOTORISTAS.length];
        const placa = PLACAS[sequencia % PLACAS.length];
        const emTransito = ['em_transito', 'a_caminho_carregamento', 'patio_destino'].includes(status);

        return {
            id: 7000 + sequencia,
            numero: `V-${7000 + sequencia}`,
            oferta_id: item.id,
            status,
            inicio_em: moment().subtract(indice * 3 + 1, 'hours').format(FORMATO),
            volume: 30,
            motorista,
            cavalo: { placa, renavam: '12345678901', total_eixos: 3, rntrc: '012345678', pbt: '24.000 kg', tipo: 'Cavalo mecânico 6x2' },
            carroceria: { placa: `${placa.slice(0, 3)}9X${(sequencia % 90) + 10}`, renavam: '10987654321', total_eixos: 3, rntrc: '012345678', capacidade_liquida: '36.000 kg', tipo: 'Graneleira' },
            oferta: resumoDaOferta(item),
            situacao: emTransito ? SITUACOES[sequencia % SITUACOES.length] : 'em_local_operacional',
            eta: emTransito ? moment().add(2 + (sequencia % 6), 'hours').format(FORMATO) : null,
            km_restante: emTransito ? 40 + (sequencia * 17) % 380 : null,
            posicao: emTransito
                ? { latitude: -15.2 - (sequencia % 7) * 0.4, longitude: -55.5 + (sequencia % 5) * 0.3, velocidade_kmh: 62 + (sequencia % 20), capturado_em: moment().subtract(sequencia % 30, 'minutes').format(FORMATO) }
                : null,
            transportadora: TRANSPORTADORAS[sequencia % TRANSPORTADORAS.length],
            prazo: ['no_prazo', 'no_prazo', 'em_risco', 'atrasada'][sequencia % 4],
            sinal: SITUACOES[sequencia % SITUACOES.length] === 'sem_sinal' ? 'sem_sinal' : 'online',
            distancia_total_km: 2140,
            ocorrencia_ativa: sequencia % 7 === 0,
            sos: sequencia % 23 === 0,
            desvio_rota_km: sequencia % 9 === 0 ? 8.4 : 0,
            valor_por_tonelada: item.valores_por_eixo?.[sequencia % 2]?.valor_por_tonelada ?? 0,
            agendamento: { data: moment().add((sequencia % 5) - 2, 'days').format('YYYY-MM-DD'), hora: '08:00' },
            ordem_carregamento: { numero: `OC-${7000 + sequencia}`, url: 'https://example.com/ordem-de-carregamento.pdf' },
            rota: { distancia_km: 2140, pontos: PONTOS_DA_ROTA },
            planejado_real: [
                { etapa: 'Chegada no carregamento', planejado: '08:00', real: '08:12', desvio: '+12 min' },
                { etapa: 'Saída do carregamento', planejado: '10:30', real: '10:55', desvio: '+25 min' },
                { etapa: 'Chegada na descarga', planejado: '18:00', real: '—', desvio: '—' },
            ],
            timeline: [
                { horario: moment().subtract(indice * 3 + 1, 'hours').format(FORMATO), evento: 'Viagem agendada', local: item.armazem_origem.emp_nome_fantasia, usuario: 'Transportadora', ambiente: 'Painel' },
                { horario: moment().subtract(indice * 2 + 1, 'hours').format(FORMATO), evento: 'Saiu para o carregamento', local: item.armazem_origem.emp_municipio, usuario: motorista.nome, ambiente: 'App' },
                { horario: moment().subtract(indice + 1, 'hours').format(FORMATO), evento: 'Posição recebida', local: 'BR-163', usuario: motorista.nome, ambiente: 'App' },
            ],
            anexos: [
                { id: sequencia * 10 + 1, nome: 'Ordem de embarque.pdf', tipo: 'Ordem de embarque', url: 'https://example.com/ordem-de-embarque.pdf' },
                { id: sequencia * 10 + 2, nome: 'Nota fiscal.xml', tipo: 'NF-e', url: 'https://example.com/nota-fiscal.xml' },
            ],
        };
    }));

export const COMPOSICOES_DA_FROTA = MOTORISTAS.slice(0, 3).map((motorista, indice) => ({
    id: 9500 + indice,
    motorista,
    cavalo: { placa: PLACAS[indice], tipo: 'Cavalo mecânico 6x2', total_eixos: indice === 2 ? 6 : 5 },
    carroceria: { placa: `${PLACAS[indice].slice(0, 3)}7K${indice + 10}`, tipo: 'Graneleira' },
    capacidade_toneladas: indice === 2 ? 37 : 32,
}));
